import { Container } from '@chakra-ui/react';
import { resolveFields } from '../Fields';
import { ElectionPagePost } from '../../types';
import ArticleContainer from '../ArticleContainer';
import TeaserHeroFull from '../TeaserHeroFull';
import { splitFields } from './Page';
import { BlocksProvider } from '../../lib/blocks.context';
import { BlockRenderer } from '../Fields/BlockRenderer';

const ElectionPage = ({ fields }: ElectionPagePost) => {
  const [hero, contentFields] = resolveFields(fields);
  const { basicFields, sectionFields } = splitFields(contentFields, [
    'core/',
    'buttons',
    'acf/features-block',
  ]);

  return (
    <ArticleContainer>
      {hero && <TeaserHeroFull gridRow="1" {...hero} />}
      <Container maxW="container.sm" variant="noSpacing">
        <BlocksProvider value={{ layoutType: 'basic' }}>
          <BlockRenderer blocks={basicFields} />
        </BlocksProvider>
      </Container>
      <BlockRenderer blocks={sectionFields} />
    </ArticleContainer>
  );
};

export default ElectionPage;
